import React from "react";

import Container from "@mui/material/Container";
import ApplicationPanel from "../application/ApplicationPanel";
import ApplicationAccountsBrowse from "./ApplicationAccountsBrowse";
import ApplicationHeader from "../application/ApplicationHeader";
import { createAppQueryClient } from "../application/queryClients";
import { AppQueryClientProvider } from "../application/AppQueryClientProvider";

// Create a client
const queryClient = createAppQueryClient({
  refetchOnWindowFocus: false,
  refetchOnMount: false,
  refetchOnReconnect: false,
  retry: false,
  staleTime: Infinity,
});
const ManageApplicationAccounts = () => {
  return (
    <Container id="manage-application-accounts" disableGutters>
      <ApplicationHeader />

      <ApplicationPanel>
        <AppQueryClientProvider client={queryClient}>
          <ApplicationAccountsBrowse />
        </AppQueryClientProvider>
      </ApplicationPanel>
    </Container>
  );
};

export default ManageApplicationAccounts;
